<template>
  <div class="flex flex-wrap">
    <div class="w-full mt-12 mb-12 px-4">
      <div
        class="relative bg-white flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded"
      >
        <BannerNotification />
        <InstanceTableHeader :title="title" :componentId="compId" />
        <div class="block w-full">
          <div
            v-if="getLoading"
            class="flex flex-col py-10 justify-center items-center m-10"
          >
            <!-- https://gannon.tv/intro -->
            <img width="260" src="@/assets/imgs/loading.gif" alt="loading" />
            <h3>Loading...</h3>
          </div>
          <InstanceTable
            v-if="!getLoading && getFilteredInstanceInfo.length"
            :InstanceList="InstanceList"
            :DraftList="DraftList"
            :componentId="compId"
          />
          <p
            v-if="!getLoading && !getFilteredInstanceInfo.length"
            class="flex items-center justify-center py-5"
          >
            No Instance Found...
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import BannerNotification from "@/components/Shared/Notification/BannerNotification";
import InstanceTable from "@/components/ComponentModule/InstanceTable/InstanceTable";
import InstanceTableHeader from "@/components/ComponentModule/InstanceTable/InstanceTableHeader";

export default {
  name: "ComponentInstanceList",
  components: {
    InstanceTable,
    InstanceTableHeader,
    BannerNotification
  },
  mounted() {
    this.$store.dispatch(Actions.FETCH_INSTANCE_INFO, {
      region: this.getRegion,
      componentId: this.$route.params.id
    });
    this.$store.dispatch(Actions.FETCH_DRAFT_INFO, {
      region: this.getRegion,
      componentId: this.$route.params.id
    });
  },
  computed: {
    compId() {
      return this.$route.params.id;
    },
    title() {
      let compId = this.$route.params.id;
      let comp = this.getAllComponent.find((item) => {
        return item.id === compId;
      });
      if (comp) {
        return comp.name;
      } else {
        return "";
      }
    },
    InstanceList() {
      if (this.getFilteredInstanceInfo) {
        return this.getFilteredInstanceInfo.map((item) => {
          return {
            id: item.id,
            name: item.instance_name,
            description: item.description
          };
        });
      } else {
        return [];
      }
    },
    DraftList() {
      // getInstanceDraft
      if (this.getInstanceDraft) {
        return this.getInstanceDraft.map((item) => {
          return {
            id: item.id,
            name: item.instance_name,
            description: item.description
          };
        });
      } else {
        return [];
      }
    },
    ...mapGetters([
      "getAllComponent",
      "getFilteredInstanceInfo",
      "getInstanceDraft",
      "getLoading",
      "getRegion"
    ])
  },
  watch: {
    compId() {
      if (this.compId) {
        this.$store.dispatch(Actions.FETCH_INSTANCE_INFO, {
          region: this.getRegion,
          componentId: this.$route.params.id
        });
        this.$store.dispatch(Actions.FETCH_DRAFT_INFO, {
          region: this.getRegion,
          componentId: this.$route.params.id
        });
        // reset page number to 0
        this.$store.dispatch(Actions.INSTANCE_SET_PAGE, 0);
      }
    }
  }
};
</script>
